import { handleSupabaseSingle, supabase } from '../../lib/supabase-unified';
import { UserLessonVideoInteraction } from '../../types';

/**
 * Create or update user video interaction (progress for a specific video)
 */
export const createOrUpdateUserVideoInteraction = async (
  userId: string,
  lessonVideoId: number,
  lessonId: number,
  updates: Partial<Omit<UserLessonVideoInteraction, 'id' | 'created_at' | 'updated_at' | 'user_id' | 'lesson_video_id'>>
): Promise<UserLessonVideoInteraction | null> => {
  try {
    return await handleSupabaseSingle<UserLessonVideoInteraction>(
      supabase
        .from('user_lesson_video_interactions')
        .upsert(
          {
            user_id: userId,
            lesson_video_id: lessonVideoId,
            lesson_id: lessonId,
            ...updates,
          },
          {
            onConflict: 'user_id,lesson_video_id',
          }
        )
        .select()
        .single() as any
    );
  } catch (error) {
    return null;
  }
};

/**
 * Update left_off_at_seconds for a specific video
 */
export const updateVideoLeftOffTime = async (
  userId: string,
  lessonVideoId: number,
  seconds: number,
  lessonId: number,
): Promise<void> => {
  await createOrUpdateUserVideoInteraction(userId, lessonVideoId, lessonId, {
    left_off_at_seconds: seconds,
    is_opened: true,
  });
};

/**
 * Get user video interaction for a specific video
 */
export const getUserVideoInteraction = async (
  userId: string,
  lessonVideoId: number
): Promise<UserLessonVideoInteraction | null> => {
  try {
    return await handleSupabaseSingle<UserLessonVideoInteraction>(
      supabase
        .from('user_lesson_video_interactions')
        .select('*')
        .eq('user_id', userId)
        .eq('lesson_video_id', lessonVideoId)
        .single() as any
    );
  } catch (error) {
    return null;
  }
};

/**
 * Mark a video as completed
 */
export const markVideoCompleted = async (
  userId: string,
  lessonVideoId: number,
  lessonId: number,
  completed: boolean = true
): Promise<UserLessonVideoInteraction | null> => {
  return createOrUpdateUserVideoInteraction(userId, lessonVideoId, lessonId, {
    is_completed: completed,
  });
};

